/**
 * Pure helpers for the generated project cover (initials + deterministic
 * color from the project id). Shared by the projectCover mixin (grid tile)
 * and the list view row so the treatment is identical and testable.
 */

export function coverInitials(title) {
    const t = (title ? String(title) : '').trim();
    if (!t) return '?';
    const words = t.split(/\s+/).filter(Boolean);
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return (words[0][0] + words[1][0]).toUpperCase();
}

// On-brand cover swatches: deeper steps of the site's cyan + navy tonal scales
// (website/src/styles/global.css), plus a few complementary hues (teal, indigo,
// plum, aubergine) for variety. All are dark enough for white initials to stay
// legible in light and dark mode. Deterministically cycled by project id.
//
// NOTE: two brand colors are intentionally excluded so overlaid UI stays legible:
//   #5ecfdf (brand cyan-400) — the active-pin icon color (.is-pinned).
//   #0d2744 (navy-900)       — the "Show Pass" tag background (.pb-showpass); a
//                              cover in this color would swallow the tag.
const COVER_SWATCHES = [
    '#2fb2c7', // cyan-500
    '#2490a8', // cyan-600
    '#237587', // cyan-700
    '#245f6f', // cyan-800
    '#164e7d', // navy-500
    '#14406a', // navy-600
    '#113456', // navy-700
    '#2b9c8a', // teal (complementary)
    '#3d5aa9', // indigo (complementary)
    '#6d4f9c', // plum (complementary)
    '#4e3a78', // aubergine (complementary — deep plum)
];

export function coverColor(id) {
    const s = id ? String(id) : '';
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
        hash = ((hash * 31) + s.charCodeAt(i)) % 1000000007;
    }
    // Same project id always maps to the same on-brand swatch.
    return COVER_SWATCHES[hash % COVER_SWATCHES.length];
}

export function hasPoster(project, failed) {
    return !!(project && project.posterUrl && String(project.posterUrl).trim()) && !failed;
}


// WEBPACK FOOTER //
// ./src/lib/projectCover.js